"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientDatabroker = void 0;
__exportStar(require("@itm21st/databroker-core"), exports);
class Databroker {
    config;
    constructor(config) {
        this.config = config;
        // Ensure that the baseURL ends with a trailing '/'
        if (!config.baseURL.endsWith("/")) {
            this.config.baseURL = this.config.baseURL + "/";
        }
    }
    getToken() {
        if (typeof this.config.token === "string") {
            return Promise.resolve(this.config.token);
        }
        return this.config.token();
    }
    async delete(request) {
        const response = await fetch(this.config.baseURL + "delete", {
            method: "POST",
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${await this.getToken()}`
            }
        });
        if (!response.ok) {
            throw new Error(await response.text());
        }
        return response.json();
    }
    async insert(request) {
        const response = await fetch(this.config.baseURL + "insert", {
            method: "POST",
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${await this.getToken()}`
            }
        });
        if (!response.ok) {
            throw new Error(await response.text());
        }
        return response.json();
    }
    async update(request) {
        const response = await fetch(this.config.baseURL + "update", {
            method: "POST",
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${await this.getToken()}`
            }
        });
        if (!response.ok) {
            throw new Error(await response.text());
        }
        return response.json();
    }
    async query(request) {
        const response = await fetch(this.config.baseURL + "query", {
            method: "POST",
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${await this.getToken()}`
            }
        });
        if (!response.ok) {
            throw new Error(await response.text());
        }
        return response.json();
    }
    async search(request) {
        const response = await fetch(this.config.baseURL + "search", {
            method: "POST",
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${await this.getToken()}`
            }
        });
        if (!response.ok) {
            throw new Error(await response.text());
        }
        return response.json();
    }
    async sproc(request) {
        const response = await fetch(this.config.baseURL + "sproc", {
            method: "POST",
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${await this.getToken()}`
            }
        });
        if (!response.ok) {
            throw new Error(await response.text());
        }
        return response.json();
    }
}
exports.default = Databroker;
class ClientDatabroker {
    config;
    constructor(config) {
        this.config = config;
        // Ensure that the baseURL ends with a trailing '/'
        if (!this.config.baseURL.endsWith("/")) {
            this.config.baseURL = this.config.baseURL + "/";
        }
        this.config.baseURL = `${this.config.baseURL}${this.config.app}/sproc`;
    }
    getToken() {
        if (typeof this.config.token === "string") {
            return Promise.resolve(this.config.token);
        }
        return this.config.token();
    }
    async sproc(request) {
        const response = await fetch(this.config.baseURL, {
            method: "POST",
            body: JSON.stringify(request),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${await this.getToken()}`
            }
        });
        if (!response.ok) {
            throw new Error(await response.text());
        }
        return response.json();
    }
}
exports.ClientDatabroker = ClientDatabroker;
//# sourceMappingURL=index.js.map